/**
 * Video Hero Module
 *
 * Handles video autoplay and scroll-to-next-section functionality.
 */

/**
 * Initialize video autoplay for a hero section
 */
function initVideoAutoplay(hero) {
  const video = hero.querySelector('video');
  if (video) {
    video.play().catch(() => {
      // Autoplay was prevented by browser - this is expected behavior
    });
  }
}

/**
 * Initialize scroll indicator button
 */
function initScrollIndicator(hero) {
  const scrollBtn = hero.querySelector('.video-hero__scroll-indicator');
  if (!scrollBtn) {
    return;
  }

  scrollBtn.addEventListener('click', () => {
    const bottom = hero.getBoundingClientRect().bottom + window.scrollY;
    window.scrollTo({ top: bottom, behavior: 'smooth' });
  });
}

/**
 * Initialize all video hero components on the page
 */
export function init() {
  const heroes = document.querySelectorAll('.video-hero');
  heroes.forEach((hero) => {
    initVideoAutoplay(hero);
    initScrollIndicator(hero);
  });
}
